import { SmartStartCardItem } from '../api';
import { i18n } from '@/shared/i18n';

/**
 * Mock smart start cards data organized by tab
 * This will be removed once the real endpoint is available
 *
 * Getters, not values: this object is built while the module is evaluated, so resolving per
 * read is what lets the copy follow a language change instead of freezing at import.
 */
export const MOCK_SMART_START_CARDS: Record<string, SmartStartCardItem[]> = {
  plan: [
    {
      id: 'strategy-planning',
      get title() {
        return i18n.t('springboard:springboard.smartCardMock.createAMarketingStrategy');
      },
      get toolName() {
        return i18n.t('tools:strategyAgentV3.name');
      },
      disabled: false,
      input: {
        agentId: 'strategy-agent-v3',
        prompt:
          // eslint-disable-next-line i18next/no-literal-string -- rendered to the user and sent verbatim to the agent as the prompt
          'Help me plan development of a marketing strategy for a new product or service with guidance on the brand, target audience, and market trends.',
      },
    },
  ],
  create: [
    {
      id: 'generate-copy',
      get title() {
        return i18n.t('springboard:springboard.smartCardMock.generateMarketingCopy');
      },
      get toolName() {
        return i18n.t('tools:copyGenerationAgent.name');
      },
      disabled: false,
      input: {
        agentId: 'copy-generation',
        prompt:
          // eslint-disable-next-line i18next/no-literal-string -- rendered to the user and sent verbatim to the agent as the prompt
          'Create engaging social media captions for a marketing campaign promoting a product or services.',
        options: {
          // eslint-disable-next-line i18next/no-literal-string -- channel identifier sent to the agent, never rendered
          channels: ['instagram'],
          variations: 3,
        },
      },
    },
    {
      id: 'create-images',
      get title() {
        return i18n.t('springboard:springboard.smartCardMock.createAiImages');
      },
      get toolName() {
        return i18n.t('tools:imageGenerationAgent.name');
      },
      disabled: false,
      input: {
        agentId: 'image-generation',
        prompt:
          // eslint-disable-next-line i18next/no-literal-string -- rendered to the user and sent verbatim to the agent as the prompt
          'Help me create an AI-generated image by guiding me through the information you need.',
      },
    },
  ],
  scale: [
    {
      id: 'localize-campaign',
      get title() {
        return i18n.t('springboard:springboard.smartCardMock.localizeAMarketingCampaign');
      },
      get toolName() {
        return i18n.t('tools:localizationAgent.name');
      },
      disabled: false,
      input: {
        agentId: 'localization-agent',
        prompt:
          // eslint-disable-next-line i18next/no-literal-string -- rendered to the user and sent verbatim to the agent as the prompt
          'Help me localize a marketing campaign for a specific region, adapting messaging and visuals for the target market.',
      },
    },
    {
      id: 'translate-ad-copy',
      get title() {
        return i18n.t('springboard:springboard.smartCardMock.translateAdCopyForGlobal');
      },
      get toolName() {
        return i18n.t('tools:translationAgent.name');
      },
      disabled: false,
      input: {
        agentId: 'translation-agent',
        prompt:
          // eslint-disable-next-line i18next/no-literal-string -- rendered to the user and sent verbatim to the agent as the prompt
          'Translate ad copy for global use while preserving brand voice, tone, and cultural nuances.',
      },
    },
    {
      id: 'region-specific-variations',
      get title() {
        return i18n.t('springboard:springboard.smartCardMock.createRegionSpecificVariations');
      },
      get toolName() {
        return i18n.t('tools:toolsHub.toolsHubConstants.adaptation');
      },
      disabled: false,
      input: {
        agentId: 'adaptation-agent',
        prompt:
          // eslint-disable-next-line i18next/no-literal-string -- rendered to the user and sent verbatim to the agent as the prompt
          'Create region-specific variations of existing marketing content, adapting visuals, copy, and formats for different markets.',
      },
    },
  ],
  deliver: [],
};
